// 组件类
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Router } from "@angular/router";
import { ToolbarButton } from "./constants";

@Component({
  selector: "rs-toolbar",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RSToolbarComponent implements AfterViewInit {
  @Input() buttons: ToolbarButton[] = [];
  @Input() disabledOptions: { [key: string]: any } = {};

  @ViewChild("toolbarContainer", { static: false })
  toolbarContainer!: ElementRef;

  @ViewChildren("toolbarItem") buttonElements!: QueryList<ElementRef>;

  constructor(public router: Router, private ref: ChangeDetectorRef) {}
  ngAfterViewInit(): void {
    this.updateButtonVisibility();
  }

  visibleButtons: ToolbarButton[] = [];
  hiddenButtons: ToolbarButton[] = [];

  public updateButtonVisibility(): void {
    if (!this.toolbarContainer || !this.buttonElements) return;

    const buttonRefs = this.buttonElements.toArray();
    const containerWidth = this.toolbarContainer.nativeElement.offsetWidth - 50;
    // console.log("containerWidth", containerWidth);
    let totalWidth = 0;
    const menuButtonWidth = 60;

    this.visibleButtons = [];
    this.hiddenButtons = [];

    for (let i = 0; i < buttonRefs.length; i++) {
      const buttonWidth =
        buttonRefs[i].nativeElement.getBoundingClientRect().width;
      // console.log("buttonWidth", buttonWidth);
      if (
        totalWidth +
          4 + // 4px margin between buttons
          buttonWidth +
          (i < buttonRefs.length - 1 ? menuButtonWidth : 0) <=
        containerWidth
      ) {
        this.visibleButtons.push(this.buttons[i]);
        buttonRefs[i].nativeElement.classList.remove("temp-hidden");
        totalWidth += buttonWidth;
      } else {
        buttonRefs[i].nativeElement.classList.add("temp-hidden");
        this.hiddenButtons.push(this.buttons[i]);
      }
    }
    // console.log("visibleButtons", this.visibleButtons);
    // console.log("hiddenButtons", this.hiddenButtons);
    this.ref.detectChanges();
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.updateButtonVisibility();
  }
}
